import React, { useState } from 'react';
import moment from 'moment';
import AccommodationSearchForm from 'Views/AccommodationSearch/components/AccommodationSearchFormCompact';

const API_DATE_FORMAT = 'YYYY-MM-DD';

const AccommodationSearchCompact = () => {
  const [petApproved, setPetApproved] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);

  function search(e) {
    e.preventDefault();

    const searchUrl = new URL(drupalSettings.search_url);

    searchUrl.searchParams.append(
      'startDate',
      startDate ? moment(startDate).format(API_DATE_FORMAT) : ''
    );
    searchUrl.searchParams.append(
      'endDate',
      endDate ? moment(endDate).format(API_DATE_FORMAT) : ''
    );
    searchUrl.searchParams.append('adults', adults);
    searchUrl.searchParams.append('children', children);
    searchUrl.searchParams.append('infants', infants);
    searchUrl.searchParams.append(
      'pets',
      petApproved && petApproved == 1 ? 1 : 0
    );

    window.open(searchUrl);
  }

  return (
    <div>
      <AccommodationSearchForm
        setPets={setPetApproved}
        petApproved={petApproved}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        adults={adults}
        setAdults={setAdults}
        kids={children}
        setChildren={setChildren}
        infants={infants}
        setInfants={setInfants}
        onSubmit={search}
        buttonText={Drupal.t('Search for accommodation')}
        availabilityFound={true}
      />
    </div>
  );
};

export default AccommodationSearchCompact;
